
const TooltipTranslation = {

    _enterprisePartnerIdEmpty: {
        pt_br: "Preencha o ID do parceiro para visualizar informações do empreendimento",
        en_us: "Fill in the partner ID to view enterprise information",
        es_es: "Rellene el ID de socio para ver la información de la empresa"
    },
    
    _userPartnerIdEmpty: {
        pt_br: "Preencha o ID do parceiro para realizar operações dentro do sistema",
        en_us: "Fill in the partner ID to perform operations within the system",
        es_es: "Complete la identificación del socio para realizar operaciones dentro del sistema"
    }

}

export default TooltipTranslation;